// extracted by mini-css-extract-plugin
module.exports = {"yellowButton":"Button_yellowButton__1dH2K","buttongradual":"Button_buttongradual__1VG8_","animate":"Button_animate__3bwla"};